/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContactCreateDto } from '../../models/sales-contact-create-dto';
import { SalesContactResponseDto } from '../../models/sales-contact-response-dto';

export interface ContactsControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesContactCreateDto
}

export function contactsControllerCreate(http: HttpClient, rootUrl: string, params: ContactsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contactsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContactResponseDto>;
    })
  );
}

contactsControllerCreate.PATH = '/o2-sales/contacts/{tenant}';
